import React from 'react';
import { Brain } from 'lucide-react';
import ProjectTemplate from './ProjectTemplate';

const Neuro = () => {
  const project = {
    title: 'Yamai Neuro',
    tagline: 'AI-Powered Analysis of Brain Signals and Neural Patterns',
    icon: Brain,
    color: '#7C3AED',
    overview: 'Yamai Neuro leverages advanced deep learning algorithms to analyze electroencephalography (EEG) and magnetic resonance imaging (MRI) data for early detection of neurological conditions. Our system focuses on identifying patterns associated with epilepsy, Alzheimer\'s disease, and other neurodegenerative disorders.',
    problems: [
      {
        title: 'Complex Signal Interpretation',
        description: 'EEG and brain imaging data are highly complex, requiring specialized expertise and significant time to interpret accurately.',
      },
      {
        title: 'Early Detection Challenges',
        description: 'Many neurological conditions develop gradually, with subtle early warning signs that are easy to miss.',
      },
      {
        title: 'Limited Specialist Access',
        description: 'Neurologists and specialized imaging technicians are in short supply, creating diagnostic bottlenecks.',
      },
      {
        title: 'Subjectivity',
        description: 'Manual interpretation of brain signals can vary between practitioners, affecting diagnosis consistency.',
      },
    ],
    solutions: [
      'Deep learning models trained on thousands of EEG recordings to identify abnormal neural patterns',
      'MRI image segmentation for detecting structural brain changes associated with neurodegenerative diseases',
      'Real-time seizure prediction and detection algorithms for epilepsy management',
      'Explainable AI showing which brain regions and signal features contributed to the diagnosis',
      'Longitudinal tracking to monitor disease progression over time',
    ],
    technology: 'Yamai Neuro employs convolutional neural networks (CNNs) for spatial feature extraction from MRI scans, combined with recurrent neural networks (RNNs) and transformers for temporal EEG signal analysis. Our explainability layer uses attention mechanisms and saliency maps to highlight the specific neural patterns that drove the diagnostic conclusion.',
    roadmap: [
      {
        title: 'Research & Algorithm Development (2026-2027)',
        description: 'Build and train models using public and partnered neurological datasets',
      },
      {
        title: 'Clinical Pilot Studies (2027-2028)',
        description: 'Validate with neurology departments in Dutch hospitals',
      },
      {
        title: 'Product Development (2028-2029)',
        description: 'Create user-friendly clinical interface and integration tools',
      },
      {
        title: 'Regulatory Approval & Launch (2029-2030)',
        description: 'Obtain medical device certification and begin commercial rollout',
      },
    ],
  };

  return <ProjectTemplate project={project} />;
};

export default Neuro;